import React, {Component} from 'react';
import styles from '../css/ResultsView.module.css';
import SearchBar from './SearchBar';
import Result from './Result.js';
import VacantSubstitutions from './VacantSubstitutions';
import Axios from './../../../components/Axios'

class ResultsView extends Component {
    constructor(props) {
        super(props)
        this.state = {
            USER_ID: '',
            WORK_EMAIL: '',
            NAME: '',
            ROLE: '',
            PHONE: '',
            TERR_ID: '',
            TERR_NAME: '',
            PARENT_ID: '',
            TEAM_ID: '',
            results: [],
            CurrentPage: 0,
            subTab: 'users'
        };
    }

    componentDidMount() {
        let temp = {}
        temp = this.state
        Axios('/api/v1/admin/search', temp, (data) => {
            this.props.setData(data)
            this.props.setOrgData(data)
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.data !== this.props.data) {
            this.setState({data: this.props.data});
        }
    }

    update(props) {
        let arr = []
        let ResultsPerPage = props.ResultsPerPage;
        let CurrentPage = props.CurrentPage;
        let tempStart = Math.round(CurrentPage * ResultsPerPage);
        for (let i = tempStart; (i < props.data.length) && (i < parseInt(tempStart) + parseInt(ResultsPerPage)); i++) {
            arr.push(<Result changeAdminView={this.props.changeAdminView} key={i} number={i} data={props.data[i]} />)
        }
        this.setState({results: arr});
    }

    render() {
        const { subTab } = this.state;
        let results = []
        let tempStart = Math.round(this.props.CurrentPage * this.props.ResultsPerPage);
        for (let i = tempStart; (i < this.props.data.length) && (i < parseInt(tempStart) + parseInt(this.props.ResultsPerPage)); i++) {
            results.push(<Result changeAdminView={this.props.changeAdminView} key={i} number={i} data={this.props.data[i]} />)
        }
        return (
            <div className={styles.ResultsView}>
                <div className={styles.titleBar}>
                    <div className={styles.title}>User Management</div>
                    {subTab === 'users' && (
                        <div className={styles.addUser} onClick={() => {this.props.changeAdminView(0)}}>CREATE USER</div>
                    )}
                    {subTab === 'substitutions' && (
                        <div className={styles.addUser} onClick={() => this.props.openEditDialog(null, () => {
                            // VacantSubstitutions will reload via its own ref — trigger by re-mounting
                            this.setState({ subTab: 'users' }, () => this.setState({ subTab: 'substitutions' }));
                        })}>ADD SUBSTITUTION</div>
                    )}
                </div>
                <div className={styles.tabStrip}>
                    <div
                        className={subTab === 'users' ? [styles.tab, styles.activeTab].join(' ') : styles.tab}
                        onClick={() => this.setState({ subTab: 'users' })}
                    >User List</div>
                    <div
                        className={subTab === 'substitutions' ? [styles.tab, styles.activeTab].join(' ') : styles.tab}
                        onClick={() => this.setState({ subTab: 'substitutions' })}
                    >MPN Vacant Substitutions</div>
                </div>
                {subTab === 'users' && (
                    <>
                        <div className={styles.searchBar}>
                            <SearchBar setData={this.props.setData} data={this.props.data} orgData={this.props.orgData}/>
                        </div>
                        <div className={styles.columnHeaders}>
                            <div className={styles.longlink}>USERNAME</div>
                            <div className={styles.longname}>NAME</div>
                            <div className={styles.shortrole}>ROLE</div>
                            <div className={styles.short}>TERR ID</div>
                            <div className={styles.long}>TERRITORY NAME</div>
                            <div className={styles.long}>PARENT ID</div>
                            <div className={styles.short}>TEAM</div>
                            <div className={styles.short}>STATUS</div>
                            <div className={styles.long}>ACTIONS</div>
                        </div>
                        <div className={styles.results}>
                            {results.length !== 0 ? results : 'Loading...'}
                        </div>
                    </>
                )}
                {subTab === 'substitutions' && (
                    <VacantSubstitutions
                        openEditDialog={this.props.openEditDialog}
                        openDeleteDialog={this.props.openDeleteDialog}
                    />
                )}
            </div>
        );
    }
}

export default ResultsView;
